// Logika Alpine.js dla edytora etykiet (designer)
// Inicjalizowana przez x-data="designerInitData()" w widoku designera.

document.addEventListener('alpine:init', () => {
  Alpine.data('labelDesigner', (initData) => ({
    labelW: initData.labelW || 10,
    labelH: initData.labelH || 5,
    scalePx: initData.scalePx || 37.8,
    availableFields: initData.availableFields || [],
    placedFields: initData.placedFields || [],
    saveUrl: initData.saveUrl || '',
    selectedIdx: null,
    saving: false,
    draggingField: null,
    dragOffsetX: 0,
    dragOffsetY: 0,
    isDraggingPlaced: false,
    draggingPlacedIdx: null,

    init() {
      // Nasłuch na mouseup (koniec przeciągania pola z płótna)
      document.addEventListener('mouseup', () => this.stopDrag());
      document.addEventListener('mousemove', (e) => this.moveDrag(e));
    },

    // ------- computed -------

    get selectedField() {
      if (this.selectedIdx === null || this.selectedIdx >= this.placedFields.length) return null;
      return this.placedFields[this.selectedIdx];
    },

    isPlaced(key) {
      if (key === 'separator' || key === 'static_text') return false;
      return this.placedFields.some(f => f.key === key);
    },

    // ------- styl płótna -------

    canvasStyle() {
      return {
        width: `${this.labelW * this.scalePx}px`,
        height: `${this.labelH * this.scalePx}px`,
        position: 'relative',
        border: '2px dashed #aaa',
        overflow: 'visible',
        background: '#fff',
        userSelect: 'none'
      };
    },

    // ------- styl pojedynczego pola na płótnie -------

    fieldStyle(pf) {
      const px = this.mmToPx(pf.x_mm);
      const py = this.mmToPx(pf.y_mm);
      const w = pf.max_width_mm > 0 ? `${this.mmToPx(pf.max_width_mm)}px` : 'auto';
      const h = pf.max_height_mm > 0 ? `${this.mmToPx(pf.max_height_mm)}px` : 'auto';
      const fontFamilyCss = pf.font_family ? `'${pf.font_family}', sans-serif` : 'Helvetica, sans-serif';

      return {
        left: `${px}px`,
        top: `${py}px`,
        width: w,
        minWidth: '40px',
        minHeight: '20px',
        height: h,
        fontSize: `${pf.font_size || 8}pt`,
        fontWeight: pf.font_style === 'bold' ? 'bold' : 'normal',
        fontStyle: pf.font_style === 'italic' ? 'italic' : 'normal',
        fontFamily: fontFamilyCss,
        padding: '2px 4px',
        boxSizing: 'border-box'
      };
    },

    // ------- konwersje -------

    mmToPx(mm) {
      return (mm / 10) * this.scalePx;
    },

    pxToMm(px) {
      return (px / this.scalePx) * 10;
    },

    // ------- dodawanie / usuwanie pól -------

    addField(field) {
      if (this.isPlaced(field.key)) return;
      const labelHmm = this.labelH * 10;
      const rawY = 5 + this.placedFields.length * 8;
      const yPos = rawY < labelHmm ? rawY : (rawY % labelHmm) + 2;
      const newField = {
        key: field.key,
        label: field.label,
        description: field.description || '',
        x_mm: 5,
        y_mm: yPos,
        max_width_mm: field.key === 'separator' ? 50 : 0,
        max_height_mm: 0,
        font_size: 8,
        font_style: 'normal',
        font_family: ''
      };
      if (field.key === 'static_text') newField.static_text_value = '';
      this.placedFields.push(newField);
      this.selectField(this.placedFields.length - 1);
    },

    removeField(idx) {
      this.selectedIdx = null;
      this.placedFields.splice(idx, 1);
    },

    selectField(idx) {
      this.selectedIdx = idx;
    },

    syncField() {
      // Wymuszamy reaktywność – Alpine 3 obserwuje mutacje bezpośrednio
    },

    // ------- drag-and-drop: pole z listy na płótno -------

    dragStart(field) {
      this.draggingField = field;
    },

    onDrop(event) {
      if (!this.draggingField) return;
      const canvas = document.getElementById('label-canvas');
      const rect = canvas.getBoundingClientRect();
      const xPx = event.clientX - rect.left;
      const yPx = event.clientY - rect.top;
      const xMm = Math.max(0, this.pxToMm(xPx));
      const yMm = Math.max(0, this.pxToMm(yPx));

      if (!this.isPlaced(this.draggingField.key)) {
        const droppedField = {
          key: this.draggingField.key,
          label: this.draggingField.label,
          description: this.draggingField.description || '',
          x_mm: parseFloat(xMm.toFixed(1)),
          y_mm: parseFloat(yMm.toFixed(1)),
          max_width_mm: this.draggingField.key === 'separator' ? 50 : 0,
          max_height_mm: 0,
          font_size: 8,
          font_style: 'normal',
          font_family: ''
        };
        if (this.draggingField.key === 'static_text') droppedField.static_text_value = '';
        this.placedFields.push(droppedField);
        this.selectField(this.placedFields.length - 1);
      } else {
        // Przesuń istniejące
        const idx = this.placedFields.findIndex(f => f.key === this.draggingField.key);
        if (idx !== -1) {
          this.placedFields[idx].x_mm = parseFloat(xMm.toFixed(1));
          this.placedFields[idx].y_mm = parseFloat(yMm.toFixed(1));
        }
      }
      this.draggingField = null;
    },

    // ------- drag-and-drop: przesuwanie istniejących pól na płótnie -------

    startDrag(event, idx) {
      this.isDraggingPlaced = true;
      this.draggingPlacedIdx = idx;
      const canvas = document.getElementById('label-canvas');
      const rect = canvas.getBoundingClientRect();
      const xPx = event.clientX - rect.left;
      const yPx = event.clientY - rect.top;
      const fieldXPx = this.mmToPx(this.placedFields[idx].x_mm);
      const fieldYPx = this.mmToPx(this.placedFields[idx].y_mm);
      this.dragOffsetX = xPx - fieldXPx;
      this.dragOffsetY = yPx - fieldYPx;
      this.selectField(idx);
      event.preventDefault();
    },

    moveDrag(event) {
      if (!this.isDraggingPlaced || this.draggingPlacedIdx === null) return;
      const canvas = document.getElementById('label-canvas');
      const rect = canvas.getBoundingClientRect();
      const xPx = event.clientX - rect.left - this.dragOffsetX;
      const yPx = event.clientY - rect.top - this.dragOffsetY;
      const xMm = this.pxToMm(xPx);
      const yMm = this.pxToMm(yPx);
      this.placedFields[this.draggingPlacedIdx].x_mm = parseFloat(xMm.toFixed(1));
      this.placedFields[this.draggingPlacedIdx].y_mm = parseFloat(yMm.toFixed(1));
    },

    stopDrag() {
      this.isDraggingPlaced = false;
      this.draggingPlacedIdx = null;
    },

    // ------- zapis -------

    async saveFields() {
      this.saving = true;
      try {
        const response = await fetch(this.saveUrl, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
          },
          body: JSON.stringify(this.placedFields)
        });
        const data = await response.json();
        if (data.status === 'ok') {
          this.showToast('Układ etykiety został zapisany ✓', 'success');
        } else {
          this.showToast(`Błąd zapisu: ${(data.errors || []).join(', ')}`, 'danger');
        }
      } catch (err) {
        this.showToast(`Błąd sieciowy: ${err.message}`, 'danger');
      } finally {
        this.saving = false;
      }
    },

    showToast(message, type = 'info') {
      const toast = document.createElement('div');
      toast.className = `alert alert-${type} position-fixed bottom-0 end-0 m-3 shadow`;
      toast.style.zIndex = 9999;
      toast.textContent = message;
      document.body.appendChild(toast);
      setTimeout(() => toast.remove(), 3000);
    }
  }));

  // Komponent Alpine.js dla formularza tworzenia / edycji szablonu etykiety.
  // Obsługuje wskaźnik orientacji, przycisk zamiany wymiarów oraz wykrywanie
  // niezgodności proporcji między wczytanym obrazem a podanymi wymiarami.
  Alpine.data('labelForm', (initialWidth, initialHeight) => ({
    width:              initialWidth  || 0,
    height:             initialHeight || 0,
    aspectWarning:      false,
    imageRatio:         '',
    labelRatio:         '',
    imageNaturalWidth:  null,
    imageNaturalHeight: null,

    isLandscape() {
      return this.width > this.height;
    },

    swapDimensions() {
      [this.width, this.height] = [this.height, this.width];
      this.checkAspect();
    },

    onImageSelect(event) {
      const file = event.target.files[0];
      if (!file) {
        this.aspectWarning = false;
        return;
      }

      const img  = new Image();
      const url  = URL.createObjectURL(file);
      img.onload = () => {
        this.imageNaturalWidth  = img.naturalWidth;
        this.imageNaturalHeight = img.naturalHeight;
        URL.revokeObjectURL(url);
        this.checkAspect();
      };
      img.src = url;
    },

    checkAspect() {
      if (!this.imageNaturalWidth || !this.width || !this.height) {
        this.aspectWarning = false;
        return;
      }

      const imgR   = this.imageNaturalWidth  / this.imageNaturalHeight;
      const labelR = parseFloat(this.width)  / parseFloat(this.height);
      const diff   = Math.abs(imgR - labelR) / labelR;

      this.aspectWarning = diff > 0.05; // ostrzegaj przy > 5% różnicy
      this.imageRatio    = `${this.imageNaturalWidth}×${this.imageNaturalHeight} px (proporcja ${imgR.toFixed(2)})`;
      this.labelRatio    = `${this.width}×${this.height} cm (proporcja ${labelR.toFixed(2)})`;
    }
  }));
});
